import { CalculatorFormValues, Co2FootprintsVOs } from 'common/types';
import { Co2FootprintVO } from 'vo';
import styled from 'styled-components/macro';
import { useTranslation } from 'react-i18next';
import { FC } from 'react';
import { CopyResultLinkButton, DownloadSocialImageButton } from './components';
import { DEVICE, TYPOGRAPHY } from '@net0-calc/common/assets/styles';

type Props = {
  formValues: CalculatorFormValues;
  co2FootprintSumVO: Co2FootprintVO;
  co2FootprintsVOs: Co2FootprintsVOs;
  answerId: string | null;
};
export const ActionButtons: FC<Props> = ({ answerId, co2FootprintsVOs, co2FootprintSumVO, formValues }) => {
  const { t } = useTranslation();

  return (
    <ActionButtonsWrapper>
      <ButtonsGroup>
        {answerId && (
          <DownloadSocialImageButton
            {...{
              formValues,
              co2FootprintSumVO,
              co2FootprintsVOs,
            }}
            answerId={answerId}
          />
        )}
        <CopyResultLinkButton answerId={answerId} />
      </ButtonsGroup>
      <ActionsDescription dangerouslySetInnerHTML={{ __html: t('general.downloadOrShare.title') }}></ActionsDescription>
    </ActionButtonsWrapper>
  );
};
const ActionButtonsWrapper = styled.div`
  margin-bottom: 48px;
`;

const ActionsDescription = styled.p`
  ${TYPOGRAPHY.captionRegular14}
  color: var(--color9);

  @media ${DEVICE.laptop} {
    ${TYPOGRAPHY.bodyRegular16}
  }
`;

const ButtonsGroup = styled.div`
  display: grid;
  grid-auto-columns: 1fr;
  grid-auto-flow: row;
  align-items: stretch;
  gap: 12px;
  margin-bottom: 16px;

  @media ${DEVICE.laptop} {
    grid-auto-flow: column;
    max-width: 700px;
    gap: 16px;
  }

  & > button {
    padding: 14px 20px;
    width: auto;
    border-radius: 12px;
    border: 1px solid var(--color10);
    transition: all 0.3s ease;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);

    &:hover {
      border-color: var(--color2);
      box-shadow: 0 4px 16px rgba(206, 17, 38, 0.08);
      transform: translateY(-1px);
    }

    @media ${DEVICE.laptop} {
      width: auto;
      min-height: 60px;
    }
  }
`;
